import styled from "styled-components";

export const Container = styled.p`
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.error};
  font-size: 0.75rem;

  @media (min-width: 640px) {
    font-size: 0.875rem;
  }
`;
